module.exports = __webpack_public_path__ + "img/notification_empty.6c23c0fd.svg";